import React, { useState } from "react";
import { Container, Row, Col, Accordion, Card } from "react-bootstrap";
import logistics from "../../Assets/logistics.png";
import poster from "../../Assets/poster.png";
import outsource from "../../Assets/global-outsource-1.png";

import jess from "../../Assets/jess.png"; 
import luna from "../../Assets/luna.png"; 
import lily from "../../Assets/lily.JPG"; 
import mia from "../../Assets/mia.png";
import gavin from "../../Assets/gavin.png";
import aaron from "../../Assets/aaron.png";
import wendy from "../../Assets/wendy.png";
import ryan from "../../Assets/ryan.jpg";


import "./About.scss";

const About = () => {
  const [activeKey, setActiveKey] = useState("0");

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const teamMembers = [
    { name: "Wendy Y.", role: "Global Sourcing Director", flags: ["🇺🇸","🇨🇳"], photo: wendy  },
    { name: "Ryan Z.", role: "Import/Export Director", flags: ["🇺🇸","🇨🇳"], photo: ryan  },
    { name: "Jess L.", role: "Business Development Manager", flags: ["🇺🇸"], photo: jess  },
    { name: "Luna W.", role: "Operations Manager", flags: ["🇺🇸", "🇨🇳", "🇻🇳"], photo: luna },
    { name: "Lily F.", role: "Strategic Sourcing Analyst", flags: ["🇺🇸","🇨🇳","🇻🇳"], photo: lily  },
    { name: "Aaron H.", role: "Operations Manager", flags: ["🇺🇸","🇨🇳"], photo: aaron  },
    { name: "Mia W.", role: "Logistics Manager", flags: ["🇨🇳"], photo: mia  },
    { name: "Gavin Z.", role: "Vendor Relations Manager", flags: ["🇺🇸"], photo: gavin  },
  ];

  return (
    <Container fluid className="about-section page-top-settings" id="about">
      <Container className="about-content">
        <h2 className="page-title center-text">About Us
          <p>From Asia to the world.</p>
        </h2>

        <Row className="hero-section mobile-column-reverse">
          <Col md={6} className="hero-text">
            <h3>
              <span className="extra">Funda Sourcing:</span> Your Trusted Asia-Pacific Procurement Partner
            </h3>
            <p>
              Funda Sourcing specializes in connecting businesses with the best suppliers across the Asia-Pacific
              region. With a factory-direct approach, we streamline the sourcing process, offering cost-effective
              and efficient solutions tailored to your needs.
            </p>
          </Col>
          <Col md={6} className="hero-image">
            <img className="feature-icon" src={logistics} alt="Funda Sourcing Company" />
          </Col>
        </Row>

        <Row className="hero-section mb-5 mt-5">
          <Col md={6} className="hero-image">
            <img className="feature-icon" src={poster} alt="Funda Sourcing, Sourcing Company, manufacturer" />
          </Col>
          <Col md={6} className="hero-text">
            <h3>Strategically Positioned for Your Global Sourcing Success</h3>
            <p>
            Headquartered in Guangzhou, Port Moresby, Ho Chi Minh City, and other key locations, we leverage our deep understanding of the Asia-Pacific market to deliver unparalleled results. Our experienced team combines local insights with global expertise, ensuring your best interests are represented throughout the value chain, while prioritizing transparency, quality, and trust in every partnership.
            </p>
          </Col>
        </Row>

        {/* Team Section */}
        <Container fluid className="team-wrapper">
          <Container>
            <Row className="team-section">
              <h2 className="center-text mb-5">Meet Our Team</h2>
              <p className="center-text mb-5">
                Our diverse, talented team works every day to provide the best service and make our clients happy.
              </p>
              {teamMembers.map((member, index) => (
                <Col key={index} lg={3} md={4} sm={6} xs={6} className="team-member">
                  <div className="team-photo">
                    <img src={member.photo} alt={member.name} />
                  </div>
                  <h4>{member.name}</h4>
                  <p>{member.role}</p>
                  <div className="flags">{member.flags.join(" ")}</div>
                </Col>
              ))}
            </Row>
          </Container>
        </Container>

        

        <Container fluid className="integration-section">
          <Container>
            <Row>
              <Col>
                <h3>
                The result? A simpler, more cost-effective service that brings greater value to you.
                </h3>
              </Col>
            </Row>
          </Container>
        </Container>


        {/* Features Section with Accordion */}
        <Row className="features-section justify-center">
          <h2 className="center mb-5">Frequently Asked Questions (FAQ)</h2>
          
          <Col md={10}>
            <Accordion activeKey={activeKey}>
              <Card>
                <Accordion.Header onClick={() => handleToggle("0")}>
                  <span>Q: What does Funda Sourcing do as a sourcing company?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <p>
                      A: Funda Sourcing handles every aspect of procurement, from identifying dependable manufacturers to overseeing production and managing delivery. Our on-the-ground team ensures quality and efficiency, taking the hassle out of sourcing for your business.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("1")}>
                  <span>Q: How does Funda Sourcing find qualified suppliers?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <p>A: We utilize a vast network of manufacturers and carefully vet suppliers to match your specifications. Our team ensures compliance with export regulations and negotiates the best pricing and terms for your project.</p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("2")}>
                  <span>Q:  What happens before and after an order is confirmed?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <p>
                      A: Before confirmation, we provide quotes, mock-ups, and product specifications for your approval. After confirmation, production begins upon deposit payment, and the timeline varies, typically ranging from 3-5 weeks.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("3")}>
                  <span>Q: When can I see samples or prototypes of my product?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="3">
                  <Card.Body>
                    <p>
                      A: Samples or prototypes can be created before full-scale production. Our team ensures they meet your specifications and provides a detailed quality check report before proceeding with production.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("4")}>
                  <span>Q: How do you ensure ethical sourcing?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="4">
                  <Card.Body>
                    <p>
                      A: We prioritize working with ethically accredited suppliers who comply with international labor laws and environmental standards. We also conduct regular audits to maintain compliance.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("5")}>
                  <span>Q: Is China the only country you source from?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="5">
                  <Card.Body>
                    <p>
                      A: No, we have an extensive network across multiple regions, including Taiwan, India, Thailand, Vietnam, Mexico, Colombia, and the United States. If your preferred sourcing country is not listed, we are open to discussing your needs and exploring alternatives.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("6")}>
                  <span>Q: How do you protect confidential information?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="6">
                  <Card.Body>
                    <p>
                      A: We prioritize data security and confidentiality by implementing strict measures, such as non-disclosure agreements and secure data-handling protocols, ensuring your proprietary information remains protected.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("7")}>
                  <span>Q: I am a startup and need to develop a new product. How can you help?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="7">
                  <Card.Body>
                    <p>
                      A: We provide end-to-end support, from product design and prototyping to sourcing qualified suppliers and overseeing production. Our expertise ensures your product aligns with your vision and market demands.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Col>
        </Row>
        
        <Container fluid className="team-wrapper">
          <Container>
            <Row className="hero-section mb-5">
              <Col md={7}>
                <h3>Contact us for a free quote today</h3>
                <p>
                  Let us help you streamline your sourcing needs. Reach out now for a customized quote and discover how Funda Sourcing can provide cost-effective, efficient solutions tailored to your business.
                </p>
              </Col>
              <Col md={5} className="hero-image">
                <img className="feature-icon" src={outsource} alt="Funda Sourcing, manufacturer" />
              </Col>
            </Row>
          </Container>
        </Container>
    
      </Container>
    </Container>
  );
};

export default About;
